import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/http-service/http-service';
import { apiConfig } from 'src/app/config/main-config';
import { appConfig } from 'src/app/config/component-config';
import { AuthService } from '../../../auth-service/authService';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { RoleService } from "../../../auth-service/role.service";
import { ReferAndEarnPopupsComponent } from './refer-and-earn-popups/refer-and-earn-popups.component';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpService, private roleService: RoleService, public dialog: MatDialog,) {
  }

  generateOtp(data) {
    return this.http.postEncoded(apiConfig.USER + appConfig.GENERATE_OTP, data);
  }

  saveAfterVerification(data) {
    return this.http.postEncoded(apiConfig.USER + appConfig.SAVE_AFTER_VERIFICATION, data);
  }

  register(data, isClient) {
    if (isClient) {
      return this.http.postEncoded(apiConfig.USER + appConfig.ADD_CLIENT, data);
    } else {
      return this.http.postEncoded(apiConfig.USER + appConfig.REGISTER, data);
    }
  }

  getUsernameData(data) {
    return this.http.getEncoded(apiConfig.USER + appConfig.SEARCH_USERNAME, data, 1);
  }

  savePassword(data) {
    return this.http.putEncoded(apiConfig.USER + appConfig.SAVE_PASSWORD, data);
  }

  resetPasswordPostLoggedIn(data) {
    return this.http.post(apiConfig.MAIN_URL + appConfig.RESET_PASSWORD, data);
  }

  loginWithPassword(data) {
    return this.http.postEncoded(apiConfig.USER + appConfig.LOGIN_WITH_PASSWORD, data);

    // return this.http.postEncoded('http://localhost:8080/userserver/api/v1/web/' + appConfig.LOGIN_WITH_PASSWORD, data);
  }

  sendWelcomeEmail(data) {
    return this.http.postEncoded(apiConfig.USER + appConfig.SEND_WELCOME_EMAIL, data);
  }

  createTeamMember(data) {
    return this.http.putEncoded(apiConfig.USER + appConfig.CREATE_TEAM_MEMBER, data);
  }

  getTeamMemberInfo(data) {
    return this.http.getEncoded(apiConfig.USER + appConfig.GET_TEAM_MEMBER_INFO, data, 1);
  }

  verifyOtp(data) {
    const url = 'https://api.msg91.com/api/v5/otp/verify?mobile=' + data.mobileNo +
      '&otp=' + data.otp + '&authkey=' + '299688ARWCWf9dMo5daa04d8';
    return this.http.getExternal(url);
  }

  handleUserData(authService: AuthService, router: Router, userData, callbackMethod?: (args: any) => void) {
    if (!userData) {
      if (callbackMethod) {
        callbackMethod(false);
      }
      return;
    }
    if (userData.token) {
      authService.setToken('Basic' + ' ' + userData.token);
      this.roleService.getRoleDetails(userData.supportRolesMasterId, (rolesData) => {
        authService.setUserInfo(userData)
        authService.setClientData(userData);
        router.navigate(['support', 'new-my-ifas']);
        this.roleService.constructAdminDataSource(rolesData);
        if (callbackMethod) {
          callbackMethod(true);
        }
      }, err => {
        if (callbackMethod) {
          callbackMethod(false);
        }
      })
    }


  }

  getCLientDetails(data) {
    return this.http.getEncoded(apiConfig.USER + appConfig.GET_CLIENT_INFO_BASED_ON_USERNAME, data, 1);
  }

  updateResetLinkExpire(data) {
    return this.http.putEncoded(apiConfig.USER + appConfig.RESET_LINK_EXPIRE, data);
  }

  openDialog() {
    const dialogRef = this.dialog.open(ReferAndEarnPopupsComponent, {
      width: '40%',
    }
    );

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);

    });
  }
}

